import React from 'react';
import { getTranslation } from '../../utils/config';
import { usePinned } from '../../hooks/use-pinned';
import { useDfContext } from '../../context/df-context';

export default function BookmarkTop(): React.ReactElement | null {
  const { pins } = usePinned();
  const [checked, setChecked] = React.useState(false);
  const {
    state: { bookmarkItems, zipItems },
  } = useDfContext();

  React.useEffect(() => {
    if (checked && zipItems !== bookmarkItems?.length) {
      setChecked(false);
    }
    if (!checked && zipItems > 0 && zipItems === bookmarkItems?.length) {
      setChecked(true);
    }
  }, [bookmarkItems?.length, checked, zipItems]);

  if (pins.length === 0) return null;

  const bookmarkDownloadAmount =
    pins.length > 1
      ? getTranslation('bookmark_title_downloads')
      : getTranslation('bookmark_title_download');

  return (
    <legend
      className="df-wishlist-top__header"
      dangerouslySetInnerHTML={{
        __html: `${getTranslation(
          'bookmark_title_amount',
          String(pins.length),
        )} ${bookmarkDownloadAmount}`,
      }}
    />
  );
}
